const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZoomIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    width: 15,
    height: 15,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8 1C4.14 1 1 4.14 1 8s3.14 7 7 7 7-3.14 7-7-3.14-7-7-7zm0 1c3.32 0 6 2.68 6 6s-2.68 6-6 6a5.994 5.994 0 0 1-6.002-6C1.998 4.68 4.68 2 8 2zm-.014 2.004a.5.5 0 0 0-.492.508L7.5 7.504l-2.996.006a.501.501 0 0 0 .002 1.002L7.5 8.506l.006 2.994a.5.5 0 1 0 1 0l-.004-2.996 2.992-.006a.5.5 0 1 0-.002-1L8.5 7.504l-.004-2.992a.5.5 0 0 0-.51-.506v-.002z",
    color: "#6e8192",
    fontFamily: "sans-serif",
    fontWeight: 400,
    overflow: "visible",
    style: {
      lineHeight: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      blockProgression: "tb",
      isolation: "auto",
      mixBlendMode: "normal"
    },
    fill: "#6e8192",
    className: "color000 svgShape"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomIcon);
export default __webpack_public_path__ + "static/media/zoom-icon.43ca471b053e7c38e2bc02ae8cc2c222.svg";
export { ForwardRef as ReactComponent };